<template>
	<div class="left-nav layout-column">
		<template v-for="(route, i) in routes">
			<router-link :to="`/dfcchallenge/${route.path}`" class="item pointer layout-row layout-align-center" :key="i">
				<div class="text">{{route.text}}</div>
				<font-awesome-icon class="arrow" icon="angle-right" />
			</router-link>
		</template>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	data() {
		return {};
	},
	computed: {
		...mapState("user", ["userInfo"]),
		routes() {
			let routes = [];
			if (this.userInfo.role == "visitor") {
				routes = [
					{
						path: "sign-up",
						text: "DFC挑戰故事"
					}
				];
			} else {
				routes = [
					{
						path: "my-DFC",
						text: "我的 DFC"
					},
					{
						path: "person-info",
						text: "個人資料"
					},
					{
						path: "sign-up",
						text: "報名DFC挑戰"
					},
					// {
					// 	path: "history-stories",
					// 	text: "我的歷屆故事"
					// },
					{
						path: "free-resource",
						text: "教學資源"
					}
				];
			}
			return routes;
		}
	},
};
</script>

<style lang="scss" scoped>
.left-nav {
	margin-right: 20px;

	.item {
		font-size: 16px;
		width: 155px;
		justify-content: space-between;
		padding: 6px 15px;
		text-decoration: none;
		color: inherit;

		&:not(.router-link-active):hover {
			color: #60adf5;
		}

		&.router-link-active {
			border-radius: 5px;
			background-color: #60adf5;
			color: white;
		}
	}
}
</style>